import { ChevronDoubleRightIcon, } from "@heroicons/react/24/outline"; // Heroicons v2
import createIcon from "./createIcon";

const LastPage = createIcon(ChevronDoubleRightIcon, "LastPage");

export default LastPage;
